import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";
import { Renewal } from "@/api/williams/renewals";

export function useWelderExpirations(welderId: string, renewal: Renewal) {
  return useQuery(queryKeys.expirations.single(welderId, renewal.process, renewal.technique), () => {
    return api.getExpirations(welderId, renewal.process, renewal.technique);
  });
}
